import { BASE_URL } from "constant";
import privateFetch from "PrivateFetch";
import {
  MASTER_TRAYEK_PAGE_ERROR,
  MASTER_TRAYEK_PAGE_LOADING,
  MASTER_TRAYEK_PAGE_SUCCESS,
  MASTER_TRAYEK_PAGE_URL,
  MASTER_TRAYEK_ADD_ERROR,
  MASTER_TRAYEK_ADD_LOADING,
  MASTER_TRAYEK_ADD_SUCCESS,
  MASTER_TRAYEK_ADD_URL,
  MASTER_TRAYEK_VIEW_ERROR,
  MASTER_TRAYEK_VIEW_LOADING,
  MASTER_TRAYEK_VIEW_SUCCESS,
  MASTER_TRAYEK_VIEW_URL,
  MASTER_TRAYEK_DELETE_ERROR,
  MASTER_TRAYEK_DELETE_LOADING,
  MASTER_TRAYEK_DELETE_SUCCESS,
  MASTER_TRAYEK_DELETE_URL,
  MASTER_TRAYEK_UPDATE_LOADING,
  MASTER_TRAYEK_UPDATE_SUCCESS,
  MASTER_TRAYEK_UPDATE_ERROR,
  MASTER_TRAYEK_UPDATE_URL,
  MASTER_TRAYEK_DELETE_TRAYEK_ERROR,
  MASTER_TRAYEK_DELETE_TRAYEK_LOADING,
  MASTER_TRAYEK_DELETE_TRAYEK_SUCCESS,
  MASTER_TRAYEK_DELETE_TRAYEK_URL,
  MASTER_TRAYEK_ADD_TRAYEK_ERROR,
  MASTER_TRAYEK_ADD_TRAYEK_LOADING,
  MASTER_TRAYEK_ADD_TRAYEK_SUCCESS,
  MASTER_TRAYEK_ADD_TRAYEK_URL,
  MASTER_TRAYEK_UPDATE_RATES_ERROR,
  MASTER_TRAYEK_UPDATE_RATES_LOADING,
  MASTER_TRAYEK_UPDATE_RATES_SUCCESS,
  MASTER_TRAYEK_UPDATE_RATES_URL,
  MASTER_TRAYEK_LIST_ERROR,
  MASTER_TRAYEK_LIST_LOADING,
  MASTER_TRAYEK_LIST_SUCCESS,
  MASTER_TRAYEK_LIST_URL,
} from "./constant";

const LOADING = "_LOADING";
const ERROR = "_ERROR";
const SUCCESS = "_SUCCESS";

const MODULE_NAME = "MASTER_KODE_TRAYEK";
const ACTION_VIEW = "_VIEW";

export const VIEW_LOADING = MODULE_NAME + ACTION_VIEW + LOADING;
export const VIEW_ERROR = MODULE_NAME + ACTION_VIEW + ERROR;
export const VIEW_SUCCESS = MODULE_NAME + ACTION_VIEW + SUCCESS;

const masterTrayekPageError = (bool) => {
  return {
    type: MASTER_TRAYEK_PAGE_ERROR,
    masterTrayekPageError: bool,
  };
};

const masterTrayekPageLoading = (bool) => {
  return {
    type: MASTER_TRAYEK_PAGE_LOADING,
    masterTrayekPageLoading: bool,
  };
};

const masterTrayekPageSuccess = (bool, masterTrayek) => {
  return {
    type: MASTER_TRAYEK_PAGE_SUCCESS,
    masterTrayekPageSuccess: bool,
    masterTrayek,
  };
};

// ACTION VIEW
const viewLoading = (bool) => {
  return {
    type: VIEW_LOADING,
    loading: bool,
  };
};

const viewError = (bool) => {
  return {
    type: VIEW_ERROR,
    error: bool,
  };
};

const viewSuccess = (bool, payload) => {
  return {
    type: VIEW_SUCCESS,
    success: bool,
    payload: payload,
  };
};

export function viewMasterKodeTrayek(data) {
  let url = BASE_URL + "master_kode_trayek/list";
  return privateFetch(viewSuccess, viewError, viewLoading, "POST", url, data);
}

export function getMasterTrayekPage(data) {
  let url = BASE_URL + MASTER_TRAYEK_PAGE_URL;
  return privateFetch(
    masterTrayekPageSuccess,
    masterTrayekPageError,
    masterTrayekPageLoading,
    "POST",
    url,
    data
  );
}

const masterTrayekAddError = (bool) => {
  return {
    type: MASTER_TRAYEK_ADD_ERROR,
    masterTrayekAddError: bool,
  };
};

const masterTrayekAddLoading = (bool) => {
  return {
    type: MASTER_TRAYEK_ADD_LOADING,
    masterTrayekAddLoading: bool,
  };
};

const masterTrayekAddSuccess = (bool) => {
  return {
    type: MASTER_TRAYEK_ADD_SUCCESS,
    masterTrayekAddSuccess: bool,
  };
};

export function masterTrayekAdd(data) {
  let url = BASE_URL + MASTER_TRAYEK_ADD_URL;
  return privateFetch(
    masterTrayekAddSuccess,
    masterTrayekAddError,
    masterTrayekAddLoading,
    "POST",
    url,
    data
  );
}

const masterTrayekViewError = (bool) => {
  return {
    type: MASTER_TRAYEK_VIEW_ERROR,
    masterTrayekViewError: bool,
  };
};

const masterTrayekViewLoading = (bool) => {
  return {
    type: MASTER_TRAYEK_VIEW_LOADING,
    masterTrayekViewLoading: bool,
  };
};

const masterTrayekViewSuccess = (bool, masterTrayek) => {
  return {
    type: MASTER_TRAYEK_VIEW_SUCCESS,
    masterTrayekViewSuccess: bool,
    masterTrayek,
  };
};

export function getMasterTrayekView(data) {
  let url = BASE_URL + MASTER_TRAYEK_VIEW_URL;
  return privateFetch(
    masterTrayekViewSuccess,
    masterTrayekViewError,
    masterTrayekViewLoading,
    "POST",
    url,
    data
  );
}

const masterTrayekDeleteError = (bool) => {
  return {
    type: MASTER_TRAYEK_DELETE_ERROR,
    masterTrayekDeleteError: bool,
  };
};

const masterTrayekDeleteLoading = (bool) => {
  return {
    type: MASTER_TRAYEK_DELETE_LOADING,
    masterTrayekDeleteLoading: bool,
  };
};

const masterTrayekDeleteSuccess = (bool, masterTrayek) => {
  return {
    type: MASTER_TRAYEK_DELETE_SUCCESS,
    masterTrayekDeleteSuccess: bool,
    masterTrayek,
  };
};

export function deleteMasterTrayek(data) {
  let url = BASE_URL + MASTER_TRAYEK_DELETE_URL;
  return privateFetch(
    masterTrayekDeleteSuccess,
    masterTrayekDeleteError,
    masterTrayekDeleteLoading,
    "POST",
    url,
    data
  );
}

const masterTrayekUpdateError = (bool) => {
  return {
    type: MASTER_TRAYEK_UPDATE_ERROR,
    masterTrayekUpdateError: bool,
  };
};

const masterTrayekUpdateLoading = (bool) => {
  return {
    type: MASTER_TRAYEK_UPDATE_LOADING,
    masterTrayekUpdateLoading: bool,
  };
};

const masterTrayekUpdateSuccess = (bool) => {
  return {
    type: MASTER_TRAYEK_UPDATE_SUCCESS,
    masterTrayekUpdateSuccess: bool,
  };
};

export function updateMasterTrayek(data) {
  let url = BASE_URL + MASTER_TRAYEK_UPDATE_URL;
  return privateFetch(
    masterTrayekUpdateSuccess,
    masterTrayekUpdateError,
    masterTrayekUpdateLoading,
    "POST",
    url,
    data
  );
}

const masterTrayekDeleteTrayekError = (bool) => {
  return {
    type: MASTER_TRAYEK_DELETE_TRAYEK_ERROR,
    masterTrayekDeleteTrayekError: bool,
  };
};

const masterTrayekDeleteTrayekLoading = (bool) => {
  return {
    type: MASTER_TRAYEK_DELETE_TRAYEK_LOADING,
    masterTrayekDeleteTrayekLoading: bool,
  };
};

const masterTrayekDeleteTrayekSuccess = (bool) => {
  return {
    type: MASTER_TRAYEK_DELETE_TRAYEK_SUCCESS,
    masterTrayekDeleteTrayekSuccess: bool,
  };
};

export function deleteTrayek(data) {
  let url = BASE_URL + MASTER_TRAYEK_DELETE_TRAYEK_URL;
  return privateFetch(
    masterTrayekDeleteTrayekSuccess,
    masterTrayekDeleteTrayekError,
    masterTrayekDeleteTrayekLoading,
    "POST",
    url,
    data
  );
}

const masterTrayekAddTrayekError = (bool) => {
  return {
    type: MASTER_TRAYEK_ADD_TRAYEK_ERROR,
    masterTrayekAddTrayekError: bool,
  };
};

const masterTrayekAddTrayekLoading = (bool) => {
  return {
    type: MASTER_TRAYEK_ADD_TRAYEK_LOADING,
    masterTrayekAddTrayekLoading: bool,
  };
};

const masterTrayekAddTrayekSuccess = (bool) => {
  return {
    type: MASTER_TRAYEK_ADD_TRAYEK_SUCCESS,
    masterTrayekAddTrayekSuccess: bool,
  };
};

export function addTrayek(data) {
  let url = BASE_URL + MASTER_TRAYEK_ADD_TRAYEK_URL;
  return privateFetch(
    masterTrayekAddTrayekSuccess,
    masterTrayekAddTrayekError,
    masterTrayekAddTrayekLoading,
    "POST",
    url,
    data
  );
}

const masterTrayekUpdateRatesError = (bool) => {
  return {
    type: MASTER_TRAYEK_UPDATE_RATES_ERROR,
    masterTrayekUpdateRatesError: bool,
  };
};

const masterTrayekUpdateRatesLoading = (bool) => {
  return {
    type: MASTER_TRAYEK_UPDATE_RATES_LOADING,
    masterTrayekUpdateRatesLoading: bool,
  };
};

const masterTrayekUpdateRatesSuccess = (bool) => {
  return {
    type: MASTER_TRAYEK_UPDATE_RATES_SUCCESS,
    masterTrayekUpdateRatesSuccess: bool,
  };
};

export function updateRates(data) {
  let url = BASE_URL + MASTER_TRAYEK_UPDATE_RATES_URL;
  return privateFetch(
    masterTrayekUpdateRatesSuccess,
    masterTrayekUpdateRatesError,
    masterTrayekUpdateRatesLoading,
    "POST",
    url,
    data
  );
}

const masterTrayekListError = (bool) => {
  return {
    type: MASTER_TRAYEK_LIST_ERROR,
    masterTrayekListError: bool,
  };
};

const masterTrayekListLoading = (bool) => {
  return {
    type: MASTER_TRAYEK_LIST_LOADING,
    masterTrayekListLoading: bool,
  };
};

const masterTrayekListSuccess = (bool, masterTrayek) => {
  return {
    type: MASTER_TRAYEK_LIST_SUCCESS,
    masterTrayekListSuccess: bool,
    masterTrayek,
  };
};

export function getMasterTrayekList(data) {
  let url = BASE_URL + MASTER_TRAYEK_LIST_URL;
  return privateFetch(
    masterTrayekListSuccess,
    masterTrayekListError,
    masterTrayekListLoading,
    "POST",
    url,
    data
  );
}
